import Ipfs from 'ipfs';
import {useEffect, useState} from 'react';

let ipfs = null;

export default function useIpfsFactory(onError) {
  const [isIpfsReady, setIpfsReady] = useState(Boolean(ipfs));
  const [ipfsInitError, setIpfsInitError] = useState(null);

  useEffect(() => {
    async function startIpfs() {
      if (ipfs) {
        console.log('IPFS already started');
      } else if (window.ipfs && window.ipfs.enable) {
        console.log('Found window.ipfs');
        ipfs = await window.ipfs.enable({commands: ['id']});
      } else {
        try {
          //console.time('IPFS Started');
          ipfs = await Ipfs.create({
            EXPERIMENTAL: {
              pubsub: true,
            },
            config: {
              Addresses: {
                Swarm: [
                  //'/dns4/node1-wrtc.dreamlink.cloud/tcp/443/wss/p2p-webrtc-star',
                  '/dns4/node1-wrtc.dreamlink.cloud/tcp/443/wss/p2p-webrtc-star/',
                  '/dns4/node2-wrtc.dreamlink.cloud/tcp/443/wss/p2p-webrtc-star/',
                  '/dns4/wrtc-star2.sjc.dwebops.pub/tcp/443/wss/p2p-webrtc-star/',
                  '/dns4/webrtc-star.discovery.libp2p.io/tcp/443/wss/p2p-webrtc-star/',
                  '/dns4/libp2p-rdv.vps.revolunet.com/tcp/443/wss/p2p-webrtc-star/',
                  '/dns4/lourdehaufen.dynv6.net/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/star.desend.ml/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/ws-star.discovery.cybernode.ai/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/webrtc-star-1.swaponline.io/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/super.peerpiper.io/tcp/13577/wss/p2p-webrtc-star/',
                  //'/dns4/web-bridge.status.im/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/star.thedisco.zone/tcp/9090/wss/p2p-webrtc-star',
                  //'/dns4/tracker.psyhead.audio/tcp/9011/wss/p2p-webrtc-star',
                  //'/dns4/1.webrtcstar.aira.life/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/2.webrtcstar.aira.life/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/3.webrtcstar.aira.life/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/star.sav3.org/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/wrtc-star1.par.cjckgpbqc.ga/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/wrtc-star2.tdt.ipfscrosspoint.net/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/ipfs.depa.digital/tcp/9091/wss/p2p-webrtc-star',
                  //'/dns4/lendnet.0confirmation.com/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/zeronet.0confirmation.com/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/akasha.cloud/tcp/443/wss/p2p-webrtc-star',
                  //'/dns4/lourdehaufen.dynv6.net/tcp/443/wss/p2p-webrtc-star/',
                  //'/dns4/node2-wrtc.dreamlink.cloud/tcp/443/wss/p2p-webrtc-star',
                  //'/dns4/node3-wrtc.dreamlink.cloud/tcp/443/wss/p2p-webrtc-star',
                  //'/dns4/node4-wrtc.dreamlink.cloud/tcp/443/wss/p2p-webrtc-star',
                  //'/dns4/colony.io/tcp/9091/wss/p2p-webrtc-star/',
                  //'/dns4/signaller.lab.metamask.io/tcp/443/wss/p2p-webrtc-star',
                  //'/dns4/webrtc-star.dist.pub/tcp/443/wss/p2p-webrtc-star',
                  //'/dns4/local1st.net/tcp/443/wss/p2p-webrtc-star',
                ],
              },
            },
          });
          //console.timeEnd('IPFS Started');
        } catch (error) {
          //console.error(error)
          //onError(error);
          ipfs = null;
          setIpfsInitError(error);
        }
      }

      window.ipfs = ipfs;

      setIpfsReady(Boolean(ipfs));
    }

    startIpfs();
    return () => {
      if (ipfs && ipfs.stop) {
        console.log('Stopping IPFS');
        ipfs.stop().catch((err) => console.error(err));
        ipfs = null;
        setIpfsReady(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {ipfs, isIpfsReady, ipfsInitError};
}
